export default {
    'ESP-C': 'A Coruña',
    'ESP-AB': 'Albacete',
    'ESP-A': 'Alicante/Alacant',
    'ESP-AL': 'Almería',
    'ESP-VI': 'Araba/Álava',
    'ESP-O': 'Asturias',
    'ESP-AV': 'Ávila',
    'ESP-BA': 'Badajoz',
    'ESP-PM': 'Balears',
    'ESP-B': 'Barcelona',
    'ESP-BI': 'Bizkaia',
    'ESP-BU': 'Burgos',
    'ESP-S': 'Cantabria',
    'ESP-CS': 'Castellón/Castelló',
    'ESP-CR': 'Ciudad Real',
    'ESP-CU': 'Cuenca',
    'ESP-CC': 'CácerESP',
    'ESP-CA': 'Cádiz',
    'ESP-CO': 'Córdoba',
    'ESP-SS': 'Gipuzkoa ',
    'ESP-GI': 'Girona',
    'ESP-GR': 'Granada',
    'ESP-GU': 'Guadalajara',
    'ESP-H': 'Huelva',
    'ESP-HU': 'HuESPca',
    'ESP-J': 'Jaén',
    'ESP-LO': 'La Rioja',
    'ESP-GC': 'Las Palmas',
    'ESP-LE': 'León',
    'ESP-L': 'Lleida',
    'ESP-LU': 'Lugo​',
    'ESP-M': 'Madrid',
    'ESP-MU': 'Murcia',
    'ESP-MA': 'Málaga',
    'ESP-NA': 'Navarra/Nafarroa',
    'ESP-OR': 'Ourense',
    'ESP-P': 'Palencia',
    'ESP-PO': 'Pontevedra',
    'ESP-SA': 'Salamanca',
    'ESP-TF': 'Santa Cruz de Tenerife',
    'ESP-SG': 'Segovia',
    'ESP-SE': 'Sevilla',
    'ESP-SO': 'Soria',
    'ESP-T': 'Tarragona',
    'ESP-TE': 'Teruel',
    'ESP-TO': 'Toledo',
    'ESP-V': 'Valencia/València',
    'ESP-VA': 'Valladolid',
    'ESP-ZA': 'Zamora',
    'ESP-Z': 'Zaragoza'
};
